import 'css-chunksrc/client/modal/styles.scss';export default {
  "resource": "_resource_1cfwj_1",
  "resourceMain": "_resourceMain_1cfwj_10",
  "projectsTransfer": "_projectsTransfer_1cfwj_14",
  "projectsTransferMain": "_projectsTransferMain_1cfwj_24",
  "projectCreation": "_projectCreation_1cfwj_30",
  "projectGroupCreation": "_projectGroupCreation_1cfwj_34",
  "taskEdition": "_taskEdition_1cfwj_41",
  "zoneCreation": "_zoneCreation_1cfwj_45",
  "folderCreation": "_folderCreation_1cfwj_54",
  "documentCreation": "_documentCreation_1cfwj_63",
  "moveDocument": "_moveDocument_1cfwj_72",
  "moveFolder": "_moveFolder_1cfwj_81",
  "documentsSelection": "_documentsSelection_1cfwj_90",
  "projectResourceGroupRemoval": "_projectResourceGroupRemoval_1cfwj_100",
  "projectRemoval": "_projectRemoval_1cfwj_109",
  "listRemoval": "_listRemoval_1cfwj_117",
  "removeTaskStatus": "_removeTaskStatus_1cfwj_130",
  "planzoneResourceAddition": "_planzoneResourceAddition_1cfwj_139",
  "project": "_project_1cfwj_14",
  "projectExternalLinks": "_projectExternalLinks_1cfwj_169",
  "milestoneCompletion": "_milestoneCompletion_1cfwj_180",
  "popup": "_popup_1cfwj_194",
  "taskStatuses": "_taskStatuses_1cfwj_205",
  "uploadDocument": "_uploadDocument_1cfwj_212",
  "planzoneResourceGroupCreation": "_planzoneResourceGroupCreation_1cfwj_221",
  "planzoneResourceToProject": "_planzoneResourceToProject_1cfwj_227",
  "planzoneResourceRemoval": "_planzoneResourceRemoval_1cfwj_239",
  "selectDocuments": "_selectDocuments_1cfwj_248",
  "projectResourceEdition": "_projectResourceEdition_1cfwj_258",
  "resourceEdition": "_resourceEdition_1cfwj_264",
  "addPlanzoneResourceToProjects": "_addPlanzoneResourceToProjects_1cfwj_278",
  "resourceEditionWrapper": "_resourceEditionWrapper_1cfwj_292",
  "commentRemoval": "_commentRemoval_1cfwj_296",
  "discussionRemoval": "_discussionRemoval_1cfwj_303",
  "createUnavailability": "_createUnavailability_1cfwj_310",
  "viewConfiguration": "_viewConfiguration_1cfwj_319",
  "retrieveProjectLogs": "_retrieveProjectLogs_1cfwj_328",
  "createProjectStrategicAxis": "_createProjectStrategicAxis_1cfwj_337",
  "createCalendarHolidays": "_createCalendarHolidays_1cfwj_351",
  "editCalendarHolidays": "_editCalendarHolidays_1cfwj_360",
  "removeCalendarHolidays": "_removeCalendarHolidays_1cfwj_378",
  "duplicateList": "_duplicateList_1cfwj_387",
  "projectResourceDeactivation": "_projectResourceDeactivation_1cfwj_400",
  "projectResourceActivation": "_projectResourceActivation_1cfwj_411",
  "resourceDeactivation": "_resourceDeactivation_1cfwj_420",
  "resourceActivation": "_resourceActivation_1cfwj_429",
  "calendarLinkExport": "_calendarLinkExport_1cfwj_438",
  "secondaryCriteria": "_secondaryCriteria_1cfwj_447",
  "addIdentityProvider": "_addIdentityProvider_1cfwj_455",
  "removeIdentityProvider": "_removeIdentityProvider_1cfwj_460",
  "assignToTask": "_assignToTask_1cfwj_469"
};